import { render, staticRenderFns } from "./UiDropDown.vue?vue&type=template&id=b89d5ad0&scoped=true&"
import script from "./UiDropDown.vue?vue&type=script&lang=js&"
export * from "./UiDropDown.vue?vue&type=script&lang=js&"
import style0 from "./UiDropDown.vue?vue&type=style&index=0&id=b89d5ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89d5ad0",
  null
  
)

export default component.exports